<template>
	<div>
		<!-- <code-login ref="myCodeLogin" @update-page="updatePage"></code-login> -->
		<head-top head-title="全部面试" goBack="true"></head-top>
		<div class="flex_c tip_class bg_a color_c font_size_b" @click="showFaceSku()">
			<div class="class_txt ellipsis_1">
				<template v-for="(value,key) in selectSku">{{key}}:{{value}}&nbsp;&nbsp;</template>
			</div>
			<van-icon name="arrow" color="#1989fa" />
		</div>

		<!-- sku分类弹出层 -->
		<van-popup v-model="showSkuPop" position="right" close-on-popstate :close-on-click-overlay="false"
			:style="{ height: '100%',overflow:'hidden'}">
			<div class="skupop" style="overflow-y: auto;">
				<div v-for="(value,key) in properties">
					<div class="color_a font_size_c properties_key">
						{{key}}
					</div>
					<div class="flex_a" style="flex-wrap:wrap;">
						<div v-for="(item,index) in value" :key="index">
							<div class="properties_value_item font_size_b" :class="item==chooseSku[key]?'active':''"
								@click="choose_prop(key,item)">
								{{item}}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="skuSelectBtn flex_a color_b font_size_a">
				<div class="btn_reset" @click="reset_sku()">重置</div>
				<div class="btn_sub" @click="sub_sku()">确定</div>
			</div>
		</van-popup>

		<div class="content faceListPadding">
			<!-- 分销入口 -->
			<!-- <div v-if="distributeStatus" class="share_div" @click="distributionShare">
				<img :src="resourceDomain+shareBgPic" class="share_bg_index" />
			</div> -->
			<!-- 课程列表 -->
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-list :offset="40" v-model="loading" :finished="finished" :immediate-check="false"
					:finished-text="finishedText" @load="onLoad" v-if="curriculumsList.length > 0">
					<div class="curriculumsList">
						<div v-for="(item, index) in curriculumsList" :key="index">
							<div class="margina" @click="toFaceDetail(item.id)">
								<div class="bg_a curriculumitem">
									<div class="flex_a paddingb" style="justify-content:space-between;align-items: flex-start;">
										<div class="widtha">
											<div class="ellipsis_2 font_size_a">{{item.name}}</div>
											<div class="marginb ellipsis_1 font_size_b color_e">{{item.brief}}</div>
											<div class="flex_a">
												<div v-for="(t) in item.curriculumTeacherList" :key="t.id" class="flex_a"
													style="flex-direction:column;width:25%;">
													<img :src='resourceDomain + t.pic' v-if='t.pic' class="curriculumimg">
													<div class="ellipsis_1 curriculumname">
														{{t.name}}
													</div>
												</div>
											</div>
										</div>
										<div class="widthb">
											<img :src='resourceDomain + item.pic' v-if="item.pic" class="curriculumpic">
										</div>
									</div>

									<div class="flex_a" style="justify-content:space-between;">
										<div class="font_size_a" style='width:30%;color:#666;text-align:left;'><span
												style='color:#F45250;'>{{item.sellCount>99999?'99999+':item.sellCount}}</span>人购买</div>
										<div class="fw popul_right">
											<span>￥{{item.skuPriceSection==null?(item.price):item.skuPriceSection}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</van-list>
				<div v-else class="color_e font_size_c paddinga" style="text-align:center;">
					<img :src='resourceDomain+"static/icon/no_order.png"' class="noorderimg">
					暂无数据，逛逛别的分类吧~
				</div>
			</van-pull-refresh>
		</div>

		<!-- 分销分享二维码弹窗 -->
		<van-popup v-model="showQrCode" style="width: 80vw;height:126vw;overflow: hidden;">
			<div class="qrCodeTips_index fw color_d">
				长按保存海报，分享好友购买，赚取奖励
			</div>
			<vue-canvas-poster :widthPixels="1000" :painting="painting" @success="canvasSuccess"
				@fail="canvasFail"></vue-canvas-poster>
			<img style="width: 80vw;height:116vw;" :src="posterImg" alt="">
		</van-popup>
	</div>
</template>

<script>
	import headTop from "@/components/common/head.vue";
	import api from "@/apis/api";
	import tool from "@/common/tool";
	import {
		mapGetters
	} from "vuex";

	export default {
		name: "FaceList",
		components: {
			headTop: headTop,
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				curriculumsList: [],
				page: 0,
				pages: undefined,
				isLoading: false,
				loading: false,
				finished: false,
				finishedText: "",
				showSkuPop: false, //sku分类弹出层
				properties: {}, //sku分类规格属性
				selectSku: {}, //选择的sku，用于列表筛选
				chooseSku: {}, //选择的sku，用于选中状态过渡用
				token: null,

				distributorId: undefined, //分销员Id
				distributeStatus: false, //分销状态
				shareBgPic: null, //分销按钮背景图
				pid: undefined, //上级分销员id
				showQrCode: false, //是否显示分销分享二维码弹窗
				qrCodeUrl: null, //二维码链接
				distributionPoster: "", //首页分销海报图

				posterImg: '', //生成的海报图片路径
				painting: {
					width: `${document.documentElement.clientWidth*0.8}px`,
					height: `${document.documentElement.clientWidth*1.16}px`,
					background: '#ffffff',
					views: [{ // 背景图片
							type: 'image',
							url: "",
							css: {
								top: 0,
								left: 0,
								width: `${document.documentElement.clientWidth*0.8}px`,
								height: `${document.documentElement.clientWidth*1.16}px`,
							}
						},
						{ //二维码
							type: 'qrcode',
							content: '',
							css: {
								bottom: `${document.documentElement.clientWidth*0.035}px`,
								left: `${document.documentElement.clientWidth*0.065}px`,
								color: '#000',
								width: `${document.documentElement.clientWidth*0.15}px`,
								height: `${document.documentElement.clientWidth*0.15}px`,
								borderWidth: '0',
								borderColor: '#fff'
							},
						},
					],
				},
			};
		},
		beforeRouteEnter(to, from, next) {
			// 添加背景色
			document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
			next()
		},
		beforeRouteLeave(to, from, next) {
			// 去除背景色
			document.querySelector('body').setAttribute('style', '')
			next()
		},
		created() {},
		activated() {
			
			// this.updatePage()

			this.curriculumsList = []
			this.properties = {}
			this.selectSku = {}
			this.page = 0
			this.showSkuPop = false
			this.getProperties()

			this.token = this.getToken()
			this.distributionPoster = ""
			this.distributorId = undefined
			this.distributeStatus = false
			this.shareBgPic = null
			this.pid = this.$route.query.distributorId
			this.showQrCode = false
			this.qrCodeUrl = null
			this.posterImg = ""
			this.painting.views[0].url = ""
			this.painting.views[1].content = ""

			// if (this.token) {
			// 	this.getdistributorInfo()
			// 	if (this.pid) {
			// 		this.bindUserDistributor(this.pid)
			// 	}
			// }

		},
		computed: {
			...mapGetters("userModule", ["getToken"]),
		},
		methods: {
			// 调用组件中的登录成功里的自定义的更新数据事件
			// updatePage() {
			// 	this.token = this.getToken()
			// 	this.curriculumsList = []
			// 	this.page = 0
			// 	this.showSkuPop = false

			// 	this.distributionPoster = ""
			// 	this.distributorId = undefined
			// 	this.distributeStatus = false
			// 	this.shareBgPic = null
			// 	this.showQrCode = false
			// 	this.qrCodeUrl = null
			// 	this.posterImg = ""
			// 	this.painting.views[0].url = ""
			// 	this.painting.views[1].content = ""

			// 	if (this.token) {
			// 		this.getdistributorInfo()
			// 		if (this.pid) {
			// 			this.bindUserDistributor(this.pid)
			// 		}
			// 	}
			// },

			//获取分销信息
			getdistributorInfo() {
				api.post(`/distribution/curriculumFirstPageCheckDistributor`).then(r => {
					console.log(r.data, "----------------获取分销信息")
					if (r.data.distributeStatus) {
						this.distributorId = r.data.userId
						this.distributeStatus = r.data.distributeStatus
						this.shareBgPic = r.data.distributionEntrancePic
						this.distributionPoster = r.data.distributionPoster
					} else {
						this.distributorId = undefined
						this.distributeStatus = false
						this.shareBgPic = null
						this.distributionPoster = ""
					}
				})
			},
			// 打开分销分享入口
			distributionShare() {
				if (this.getToken()) {
					this.painting.views[0].url = ""
					this.posterImg = ''
					this.showQrCode = true
					this.painting.views[0].url = this.resourceDomain + this.distributionPoster + `?t=${new Date()}` //海报背景图
					this.qrCodeUrl = api.aPI_BASE_URL + '/?#/face_list/?distributorId=' + this.distributorId
					this.painting.views[1].content = this.qrCodeUrl
				} else {
					this.$store.commit('userModule/SET_login_popup_show', true)
				}
			},

			// 成功生成海报
			canvasSuccess(src) {
				this.posterImg = src; //生成是base64格式的图片
				console.log(src, "--------------成功")
			},
			// 无法生成海报
			canvasFail(err) {
				console.log(err, "-----------------失败")
			},
			// 绑定分销员和用户
			bindUserDistributor(pid) {
				api.post(`/book/bindUserDistributor/${pid}`).then(res => {
					this.$toast.clear()
				})
			},

			// 打开分类
			showFaceSku() {
				this.showSkuPop = true
				var chooseSku = {}
				for (var index in this.selectSku) {
					chooseSku[index] = this.selectSku[index]
				}
				this.chooseSku = chooseSku
			},

			// 点击选择sku分类规格属性
			choose_prop(key, item) {
				console.log(key, item, "--------点击选择sku分类规格属性---------")
				this.$set(this.chooseSku, key, item);
			},

			// 重置sku
			reset_sku() {
				var chooseSku = {}
				for (var index in this.properties) {
					chooseSku[index] = this.properties[index][0]
				}
				this.chooseSku = chooseSku
			},

			// 确定选项，并关闭
			sub_sku() {
				this.selectSku = this.chooseSku
				this.showSkuPop = false
				this.page = 0;
				this.curriculumsList = [];
				this.getFaceCurriculums();
				this.isLoading = false;
			},

			// 获取sku分类规格属性
			getProperties() {
				api
					.get("/p/faceCurriculum/getPropertiesMap")
					.then((res) => {
						console.log(res, "-----getPropertiesMap------");
						if (res.code == 20000) {
							var properties = res.data;
							var selectSku = {}
							for (var index in properties) {
								selectSku[index] = properties[index][0]
							}
							this.properties = properties
							this.selectSku = selectSku
							this.getFaceCurriculums();
						} else {
							this.$toast(res.message);
						}
					});
			},

			// 获取面试课列表
			getFaceCurriculums() {
				let curriculumsList = this.curriculumsList;
				let page = this.page + 1;
				api
					.get("/p/faceCurriculum/getFaceCurriculums", {
						page: page,
						size: 6,
						selectSku: this.selectSku
					})
					.then((res) => {
						this.$toast.clear();
						console.log(res, "-----getFaceCurriculums------");
						if (res.code == 20000) {
							if (res.data.total > 0) {
								for (var i = 0; i < res.data.curriculums.length; i++) {
									curriculumsList.push(res.data.curriculums[i]);
								}

								this.curriculumsList = curriculumsList;
								this.page = page;
								this.pages = res.data.pages;
								// 加载状态结束
								this.isLoading = false
								this.loading = false
								// 设置是否可以继续上拉加载
								if (this.page == this.pages) {
									this.finished = true
								} else {
									this.finished = false
								}
								this.finishedText = "没有更多了~"
								console.log(this.finishedText, "-----------this.finishedText")
							} else {
								this.finished = true
								this.finishedText = ""
								this.curriculumsList = []
							}

							//设置微信分享
							//分享时候安卓会把#屏蔽掉导致分享失败
							let linkUrl = api.aPI_BASE_URL + '/?#/face_list'
							let shareInfo = {
								img: "https://wenwu3.oss-cn-hangzhou.aliyuncs.com/static/book_share_pic.png",
								link: linkUrl,
								title: "文武教师",
								desc: "文武教育定制面试"
							}
							console.log("shareInof....", shareInfo)
							this.wxJssdkConfig().then(() => {
								this.wxShareReady(shareInfo);
							})
						} else {
							this.$toast(res.message);
						}
					});
			},

			wxJssdkConfig() {
				console.log("wxJssdkConfig...")
				console.log(location.href.split('#')[0])
				var _this = this;
				return new Promise((resolve) => {
					//api.post('/p/user/getWxShareInfo', {url: encodeURIComponent(location.href.split('#')[0])}).then((res) => {
					api.post('/p/user/getWxShareInfo', {
						url: location.href.split('#')[0]
					}).then((res) => {
						_this.$wx.config({
							debug: false, // 开启调试模式
							appId: res.data.appId, // 必填，公众号的唯一标识
							timestamp: res.data.timestamp, // 必填，生成签名的时间戳
							nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
							signature: res.data.signature, // 必填，签名
							jsApiList: [
								"updateAppMessageShareData", //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
								"updateTimelineShareData", //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
								"onMenuShareWeibo", //获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
							] // 必填，需要使用的JS接口列表
						})
						console.log("调用后台接口成功>>>>>>>>>>>>>>>>>>", res)
						resolve(res)
					}).catch((error) => {
						console.log(error)
					});
				})
			},

			/**微信jssdk分享方法 */
			wxShareReady(shareInfo) {
				console.log("进入微信jssdk分享方法.........")
				var _this = this;
				this.$wx.ready(() => {
					_this.$wx.updateAppMessageShareData({
						title: shareInfo.title, // 分享标题
						link: shareInfo.link, // 分享链接
						imgUrl: shareInfo.img,
						desc: shareInfo.desc,
					}, function(res) {
						window.console.log(res)
					});
					_this.$wx.updateTimelineShareData({
						title: shareInfo.title, // 分享标题
						link: shareInfo.link, // 分享链接
						imgUrl: shareInfo.img,
						desc: shareInfo.desc,
					}, function(res) {
						window.console.info(res)
					});
				})
				_this.$wx.error(function(res) {
					window.console.log(res)
					//config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
				});
			},
			/**下拉刷新 */
			onRefresh() {
				console.log("222")
				this.page = 0;
				this.curriculumsList = [];
				this.getFaceCurriculums();
				this.isLoading = false;
			},
			/**上拉加载 */
			onLoad() {
				console.log("1111")
				if (this.page == this.pages) {
					this.$toast('没有更多咯~')
				} else {
					this.getFaceCurriculums()
				}
			},


			/* 跳转课程详情 */
			toFaceDetail(faceCurriculumId) {
				this.$router.push({
					'path': '/face_detail',
					query: {
						faceCurriculumId: faceCurriculumId
					}
				})
			},
		},
	};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	// 分销
	.share_bg_index {
		display: block;
		width: 345px;
		height: 125px;
	}

	.share_div {
		width: 345px;
		padding: 10px 15px 0;
		position: relative;
	}

	.qrCodeTips_index {
		height: 10vw;
		line-height: 10vw;
		text-align: center;
		font-size: 14px;
		letter-spacing: 1px;
	}

	.tip_class {
		width: 345px;
		padding: 0 15px;
		height: 40px;
		position: fixed;
		left: 0;
		right: 0;
		top: 48px;
		z-index: 999;
	}

	.class_txt {
		width: 320px;
	}

	.skupop {
		height: calc(100% - 65px);
		width: 270px;
		padding: 0 15px 65px;
	}

	.properties_key {
		padding: 15px 0 10px;
	}

	.properties_value_item {
		padding: 0 15px;
		height: 30px;
		line-height: 30px;
		margin-bottom: 13px;
		margin-right: 15px;
		border-radius: 15px;
		background-color: #f5f5f5;
		color: #666;
	}

	.skupop .active {
		background-color: rgba(30, 159, 255, .1) !important;
		color: #1E9FFF !important;
	}

	.skuSelectBtn {
		position: fixed;
		bottom: 0;
		z-index: 999;
		background-color: #eee;
		left: 0;
		right: 0;
		padding: 10px 15px;
		justify-content: flex-end !important;
	}

	.skuSelectBtn div {
		width: 80px;
		height: 34px;
		line-height: 34px;
		text-align: center;
	}

	.btn_reset {
		background-color: #ff8a21;
		border-radius: 17px 0 0 17px;
	}

	.btn_sub {
		background-color: #FF0000;
		border-radius: 0 17px 17px 0;
	}

	/* 图书 */
	/* 搜索开始 */
	.faceListPadding {
		padding-top: 90px;
	}

	.margina {
		margin-top: 15px;
	}

	.widthb {
		width: 100px;
	}

	.curriculumpic {
		width: 100px;
		height: 100px;
		border-radius: 50%;
	}

	.faceListPadding .popul_right {
		width: 70%;
		text-align: right;
		color: #F45250;
		font-size: 20px;
		font-weight: 700;
	}

	.curriculumimg {
		width: 35px;
		height: 35px;
		border-radius: 50%;
	}

	.curriculumname {
		width: 100%;
		font-size: 11px;
		color: #666;
		text-align: center;
		margin-top: 5px;
	}

	.paddingb {
		padding-bottom: 10px
	}

	.marginb {
		margin: 10px 0;
	}

	.widtha {
		width: 215px;
	}

	.curriculumitem {
		border-radius: 8px;
		padding: 10px;
	}

	.noorderimg {
		display: block;
		width: 345px;
		height: 172.5px;
		margin: 15vh auto 25px;
	}

	.paddinga {
		text-align: center;
		padding: 15px 0;
	}

	.noorder {
		width: 345px;
		height: 172.5px;
		margin: 15vh auto 25px;
	}

	.curriculumsList {
		flex-wrap: wrap;
		width: 345px;
		margin: 0 auto;
	}

	.bookitem {
		width: 163px;
		margin-right: 14px;
		margin-bottom: 15px;
		border-radius: 5px;
		border: 1px solid #ccc;
	}

	.bookitem:nth-child(2n) {
		margin-right: 0;
	}

	.bookpic {
		width: 163px;
		height: 163px;
		border-radius: 5px 5px 0 0;
		display: block;
	}

	.bookdetail {
		background-color: #f9f9f9;
		border-radius: 0 0 5px 5px;
	}

	.bookname {
		height: 40px;
		line-height: 20px;
		padding: 10px 8px 8px;
		width: 147px;
	}

	.number {
		padding: 0 8px 8px;
		width: 147px;
	}

	.money {
		font-size: 10px;
	}

	.btns {
		border-top: 1px solid #ccc;
		padding: 10px 8px;
		width: 147px;
	}
</style>